import React from 'react';
import PropTypes from 'prop-types';
import Queue from '../../../queue/QueueContainer';
import { isIosBridge } from '../../../iosBridge/helpers';

const GiftCardsDownload = ({ onClick }) => {
  if (isIosBridge()) {
    return (
      <Queue
        name="reports"
        btnLabel="Export CSV"
        btnClass="c-btn c-btn--medium"
        jobName="gift-cards-report"
        label="Export Gift Cards Report"
      />
    );
  }

  return (
    <button
      onClick={onClick}
      className="c-btn c-btn--medium u-width-120"
      type="button"
    >
      Download
    </button>
  );
};

GiftCardsDownload.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default GiftCardsDownload;
